// extracted by mini-css-extract-plugin
export default {"CurPage":"CurPage_CurPage__hGjhS","currentPage":"CurPage_currentPage__Vfl8N"};